import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../Components/Header";
import "./ProductDetails.css";
import axios from "axios";
import BASE_URL from "../config";

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // ✅ add this

  const [product, setProduct] = useState(null);
  const [activeImg, setActiveImg] = useState("");


  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/Products/${id}`
        );

        setProduct(response.data);

        const mainImage =
          response.data.images?.find((x) => x.isMain)?.imageUrl ||
          response.data.images?.[0]?.imageUrl ||
          "";

        setActiveImg(mainImage);
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) return <p>Loading...</p>;

  return (
    <div className="productdetails-wrapper">
      <div className="productdetails-container">
        <Header />

        {/* TOP BAR */}
        <div className="productdetails-top-bar">
          <div>
            <h2>Product Details</h2>
            <p className="productdetails-sub">
              View complete product information
            </p>
          </div>

          <div className="productdetails-top-actions">
            {/* ✅ DELETE POPUP OPEN */}
            <button
              className="productdetails-delete-btn"
              onClick={() =>
                navigate("/delete-popup", {
                  state: {
                    background: location,
                    id: product.id,
                    name: product.name,
                  },
                })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#FFFFFF"
              >
                <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
              </svg>
              Delete
            </button>

            {/* EDIT */}
            <button
              className="productdetails-edit-btn"
              onClick={() => navigate(`/edit-product/${product.id}`)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#FFFFFF"
              >
                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
              </svg>
              Edit Product
            </button>
          </div>
        </div>

        {/* IMAGE SECTION */}
        <div className="productdetails-image-section">
          <div className="productdetails-main-image">
            <img src={activeImg} alt="product" />
          </div>
        </div>

        {/* THUMBNAILS */}
        <div className="productdetails-thumbs">
          {product.images?.map((img, i) => (
            <img
              key={i}
              src={img.imageUrl}
              alt="thumb"
              className={
                activeImg === img.imageUrl
                  ? "productdetails-thumb active"
                  : "productdetails-thumb"
              }
              onClick={() => setActiveImg(img.imageUrl)}
            />
          ))}
        </div>

        {/* PRODUCT CARD */}
        <div className="productdetails-card new-ui">
          <div className="productdetails-card-header">
            <div>
              <h3 className="productdetails-title">{product.name}</h3>

              <p className="productdetails-sub-text">
                {product.category?.name || "-"} / {product.subCategory}
              </p>

              <div className="productdetails-tags">
                {product.tag && <span className="tag new">{product.tag}</span>}
              </div>
            </div>

            <span className="productdetails-status active">
              {product.status === 1 ? "Active" : "Out Of Stock"}
            </span>
          </div>

          {/* PRICE */}
          <div className="productdetails-price-row">
            <span className="productdetails-new-price">₹ {product.finalPrice}</span>

            <span className="productdetails-old-price">
              ₹ {Number(product.originalPrice)}
            </span>

            <span className="productdetails-discount">{product.discountPercentage}% OFF</span>
          </div>

          <hr className="productdetails-divider" />

          {/* DESCRIPTION */}
          <div className="productdetails-desc-block">
            <h4>Description</h4>
            <p className="productdetails-desc">{product.description}</p>
          </div>
        </div>

        {/* SPECIFICATIONS */}
        <div className="productdetails-card spec-new">
          <h4 className="section-title">Specifications</h4>

          <div className="productdetails-spec-grid">
            <div className="spec-box">
              <div className="spec-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.16667 18.1083C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1083L16.6667 14.775C16.9198 14.6289 17.13 14.4187 17.2763 14.1657C17.4225 13.9127 17.4997 13.6256 17.5 13.3333V6.66666C17.4997 6.37439 17.4225 6.08734 17.2763 5.8343C17.13 5.58126 16.9198 5.37113 16.6667 5.225L10.8333 1.89166C10.58 1.74538 10.2926 1.66837 10 1.66837C9.70744 1.66837 9.42003 1.74538 9.16667 1.89166L3.33333 5.225C3.08022 5.37113 2.86998 5.58126 2.72372 5.8343C2.57745 6.08734 2.5003 6.37439 2.5 6.66666V13.3333C2.5003 13.6256 2.57745 13.9127 2.72372 14.1657C2.86998 14.4187 3.08022 14.6289 3.33333 14.775L9.16667 18.1083Z"
                    stroke="#A21803"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 18.3333V10"
                    stroke="#A21803"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.7417 5.83334L10 10L17.2584 5.83334"
                    stroke="#A21803"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.25 3.55833L13.75 7.85"
                    stroke="#A21803"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <p className="productdetails-label">Stock Quantity</p>
                <p>{product.quantity} pieces</p>
              </div>
            </div>

            <div className="spec-box">
              <div className="spec-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10.6916 1.81667C10.4744 1.71762 10.2385 1.66637 9.99989 1.66637C9.76123 1.66637 9.52536 1.71762 9.30822 1.81667L2.16656 5.06667C2.01868 5.13187 1.89295 5.23867 1.80469 5.37405C1.71643 5.50943 1.66943 5.66755 1.66943 5.82917C1.66943 5.99078 1.71643 6.14891 1.80469 6.28429C1.89295 6.41967 2.01868 6.52646 2.16656 6.59167L9.31656 9.85C9.53369 9.94904 9.76956 10.0003 10.0082 10.0003C10.2469 10.0003 10.4828 9.94904 10.6999 9.85L17.8499 6.6C17.9978 6.5348 18.1235 6.428 18.2118 6.29262C18.3 6.15724 18.347 5.99911 18.347 5.8375C18.347 5.67589 18.3 5.51776 18.2118 5.38238C18.1235 5.247 17.9978 5.1402 17.8499 5.075L10.6916 1.81667Z"
                    stroke="#F4C2C2"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.66651 10C1.66611 10.1594 1.71144 10.3155 1.7971 10.45C1.88277 10.5844 2.00519 10.6914 2.14984 10.7583L9.31651 14.0167C9.53251 14.1145 9.76689 14.1651 10.004 14.1651C10.2411 14.1651 10.4755 14.1145 10.6915 14.0167L17.8415 10.7667C17.989 10.7004 18.114 10.5926 18.2013 10.4564C18.2886 10.3203 18.3345 10.1617 18.3332 10"
                    stroke="#F4C2C2"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.66651 14.1667C1.66611 14.3261 1.71144 14.4822 1.7971 14.6166C1.88277 14.751 2.00519 14.8581 2.14984 14.925L9.31651 18.1833C9.53251 18.2811 9.76689 18.3317 10.004 18.3317C10.2411 18.3317 10.4755 18.2811 10.6915 18.1833L17.8415 14.9333C17.989 14.867 18.114 14.7592 18.2013 14.6231C18.2886 14.487 18.3345 14.3284 18.3332 14.1667"
                    stroke="#F4C2C2"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <p className="productdetails-label">Fabric Type</p>
                <p>{product.material || "-"}</p>
              </div>
            </div>

            <div className="spec-box">
              <div className="spec-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10.4882 2.155C10.1757 1.84242 9.75183 1.66676 9.30984 1.66666H3.33317C2.89114 1.66666 2.46722 1.84226 2.15466 2.15482C1.8421 2.46738 1.6665 2.8913 1.6665 3.33333V9.31C1.6666 9.75199 1.84225 10.1758 2.15484 10.4883L9.40817 17.7417C9.78693 18.118 10.2992 18.3293 10.8332 18.3293C11.3671 18.3293 11.8794 18.118 12.2582 17.7417L17.7415 12.2583C18.1179 11.8796 18.3291 11.3673 18.3291 10.8333C18.3291 10.2994 18.1179 9.78709 17.7415 9.40833L10.4882 2.155Z"
                    stroke="#D4AF37"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.25016 6.66667C6.48028 6.66667 6.66683 6.48012 6.66683 6.25C6.66683 6.01988 6.48028 5.83334 6.25016 5.83334C6.02004 5.83334 5.8335 6.01988 5.8335 6.25C5.8335 6.48012 6.02004 6.66667 6.25016 6.66667Z"
                    fill="#D4AF37"
                    stroke="#D4AF37"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <p className="productdetails-label">Category</p>
                <p>{product.category?.name || "-"}</p>
              </div>
            </div>

            <div className="spec-box highlight">
              <div className="spec-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 1.66667V18.3333"
                    stroke="#9810FA"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.1667 4.16667H7.91667C7.14312 4.16667 6.40125 4.47396 5.85427 5.02094C5.30729 5.56792 5 6.30979 5 7.08334C5 7.85689 5.30729 8.59875 5.85427 9.14573C6.40125 9.69271 7.14312 10 7.91667 10H12.0833C12.8569 10 13.5987 10.3073 14.1457 10.8543C14.6927 11.4013 15 12.1431 15 12.9167C15 13.6902 14.6927 14.4321 14.1457 14.9791C13.5987 15.526 12.8569 15.8333 12.0833 15.8333H5"
                    stroke="#9810FA"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <p className="productdetails-label">Original Price</p>
                <p>₹ {Number(product.originalPrice) + 2500}</p>
              </div>
            </div>
          </div>
        </div>

        {/* ADDITIONAL DETAILS */}
        <div className="productdetails-card spec-new">
          <h4 className="section-title">Additional Details</h4>

          <div className="productdetails-spec-grid-additional">
            <div className="spec-box-additional">
              <p className="productdetails-label-additional">SKU</p>
              <p>{product.sku || "-"}</p>
            </div>

            <div className="spec-box-additional">
              <p className="productdetails-label-additional">Weight</p>
              <p>{product.weight || "-"}</p>
            </div>

            <div className="spec-box-additional">
              <p className="productdetails-label-additional">Color</p>
              <p>
                {product.colors?.length > 0
                  ? product.colors.map((x) => x.colorName).join(", ")
                  : "-"}
              </p>
            </div>

            <div className="spec-box-additional">
              <p className="productdetails-label-additional">Size</p>
              <p>{product.size || "-"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
